import { STORAGE_CDN_PATH } from '../../storage-constants';

export type StorageAdditionalItemStructure = {
  name: string;
  imgSrc: string;
  link: {
    href: string;
    title: string;
  };
};

export const STORAGE_ADDITIONAL_ITEM_LIST: StorageAdditionalItemStructure[] = [
  {
    name: 'utp-section.all-purchases.modal-book-shelving',
    imgSrc: `${STORAGE_CDN_PATH}/categories/book-shelving-2.png/book-shelving-2.png`,
    link: {
      href: '/catalogue/knizhnye-stellazhi/',
      title: 'utp-section.all-purchases.modal-book-shelving',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-dressers',
    imgSrc: `${STORAGE_CDN_PATH}/categories/dressers-2.png/dressers-2.png`,
    link: {
      href: '/catalogue/komody/',
      title: 'utp-section.all-purchases.modal-dressers',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-shoe-racks',
    imgSrc: `${STORAGE_CDN_PATH}/categories/shoe-racks-2.png/shoe-racks-2.png`,
    link: {
      href: '/catalogue/obuvnicy/',
      title: 'utp-section.all-purchases.modal-shoe-racks',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-wall-shelves',
    imgSrc: `${STORAGE_CDN_PATH}/categories/wall-shelves-2.png/wall-shelves-2.png`,
    link: {
      href: '/catalogue/polki-nastennye/',
      title: 'utp-section.all-purchases.modal-wall-shelves',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-floor-hangers',
    imgSrc: `${STORAGE_CDN_PATH}/categories/floor-hangers-2.png/floor-hangers-2.png`,
    link: {
      href: '/catalogue/veshalki-napolnye/',
      title: 'utp-section.all-purchases.modal-floor-hangers',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-wall-hangers',
    imgSrc: `${STORAGE_CDN_PATH}/categories/wall-hangers-2.png/wall-hangers-2.png`,
    link: {
      href: '/catalogue/veshalki-nastennye/',
      title: 'utp-section.all-purchases.modal-wall-hangers',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-accessories',
    imgSrc: `${STORAGE_CDN_PATH}/categories/accessories-2.png/accessories-2.png`,
    link: {
      href: '/catalogue/aksessuary-dlya-hraneniya/',
      title: 'utp-section.all-purchases.modal-accessories',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-wardrobes-turin',
    imgSrc: `${STORAGE_CDN_PATH}/categories/wardrobes-turin-2.png/wardrobes-turin-2.png`,
    link: {
      href: '/offer/shkafy-turin/',
      title: 'utp-section.all-purchases.modal-wardrobes-turin',
    },
  },
  {
    name: 'utp-section.all-purchases.modal-storage-containers',
    imgSrc: `${STORAGE_CDN_PATH}/categories/storage-containers-2.png/storage-containers-2.png`,
    link: {
      href: '/catalogue/emkosti-dlya-hraneniya/',
      title: 'utp-section.all-purchases.modal-storage-containers',
    },
  },
];
